import React, { useMemo } from 'react';
import { TableColumn } from '@silverfort/sf-components';
import StatusColumn from './statusColumn';
import NameColumn from './nameColumn';
import DescriptionColumn from './descriptionColumn';
import { IncidentsConfiguration } from '../../types';
import SeverityColumn from "./severityColumn";
import LastChangedColumn from "./lastChangedColumn";

interface IncidentColumnDefinition extends TableColumn<IncidentsConfiguration> {
    extractValue?: (row: IncidentsConfiguration) => string | string[];
}

const useGetColumns = (
    onRowClick: (row: IncidentsConfiguration) => void
) => {
    return useMemo(() => {
        const relevantColumns: IncidentColumnDefinition[] = [
            {
                columnKey: 'isActive',
                title: '',
                render: (row) => <StatusColumn isActive={row.isActive} />,
                columnClassName: 'min-w-[48px] max-w-[48px]'
            },
            {
                columnKey: 'name',
                title: 'Incident',
                render: (row) => (
                    <div className="cursor-pointer" onClick={() => onRowClick(row)}>
                        <NameColumn name={row.name} />
                    </div>
                ),
                columnClassName: 'w-64 min-w-64 max-w-64'
            },
            {
                columnKey: 'severity',
                title: 'Severity',
                render: (row) => (
                    <div className="cursor-pointer" onClick={() => onRowClick(row)}>
                        <SeverityColumn severity={row.severity} />
                    </div>
                ),
                columnClassName: 'w-28 min-w-28 max-w-28'
            },
            {
                columnKey: 'description',
                title: 'Description',
                render: (row) => (
                    <div className="cursor-pointer w-full" onClick={() => onRowClick(row)}>
                        <DescriptionColumn description={row.description} />
                    </div>
                ),
                columnClassName: 'flex-1 min-w-0 w-full'
            },
            {
                columnKey: 'lastChanged',
                title: 'Last changed',
                render: (row) => (
                    <div className="cursor-pointer w-full" onClick={() => onRowClick(row)}>
                        <LastChangedColumn lastChanged={row.lastChanged} />
                    </div>
                ),
                columnClassName: 'w-32 min-w-32 max-w-32'
            }
        ];
        return relevantColumns;
    }, [onRowClick]);
};

export default useGetColumns;
